module.exports = __webpack_public_path__ + "assets/bicycle_active-9b5de2.svg";